import React, {FC} from "react"
import PropTypes from "prop-types"
import {get} from "lodash"

import {connect} from "@irati/store"
import {injectIntl, InjectIntl, FormattedMessage} from "@irati/utils/lang"
import id from "@irati/utils/id"
import {H4} from "@irati/ui/src/Headings"
import {ButtonLink} from "@irati/ui/src/Link"
import ExpandingList from "@irati/ui/src/ExpandingList"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import Flex from "@irati/ui/src/Flex"
import {TabTypes} from "../../enums"

import {
  ExtraPaddingCard,
  TopHr,
  BottomHr
} from "./styled"

interface Props extends InjectIntl {
  id: string,
  isMobile?: boolean,
  selectedTab: TabTypes
}

const FAQs: FC<Props> = ({isMobile, formatMessage, selectedTab, ...props}) => {
  const idNamespace = id("faqs", props)

  const listItems = () => {
    if(selectedTab === TabTypes.Cancelled) {
      return [
        {
          title: formatMessage({id: "wallet.faqs.q1.cancelledTransactionQuestion"}),
          description: formatMessage({id: "wallet.faqs.q1.cancelledTransactionAnswer"})
        }
      ]
    }

    return [
      {
        title: formatMessage({id: "wallet.faqs.q1.question"}),
        description: formatMessage({id: "wallet.faqs.q1.answer"})
      },
      {
        title: formatMessage({id: "wallet.faqs.q2.question"}),
        description: formatMessage({id: "wallet.faqs.q2.answer"})
      }
    ]
  }

  return (
    <ExtraPaddingCard id={idNamespace} small>
      <H4>
        <FormattedMessage id="wallet.faqs.title" />
      </H4>
      <TopHr />
      <ExpandingList
        id={id("faq-expanding-list", props)}
        items={listItems()} />
      <BottomHr />
      <ButtonLink
        tertiary
        cta
        id={id("read-full-faqs", idNamespace)}
        full={isMobile}
        href={formatMessage({id: "wallet.faqs.button.href"})}
        target="_blank">
        <Flex>
          <FormattedMessage id="wallet.faqs.button.text" />
          <Icon icon={IconTypes.arrowRight} marginLeft />
        </Flex>
      </ButtonLink>
    </ExtraPaddingCard>
  )
}

FAQs.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  formatMessage: PropTypes.func.isRequired
}

const mapStateToProps = ({mq}) => ({
  isMobile: get(mq, "lessThan.medium", false)
})

export default injectIntl(connect(mapStateToProps)(FAQs))
